var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.713 23.3983C18.3192 23.0111 18.3139 22.3779 18.7012 21.9841L19.9513 20.713C20.3386 20.3192 20.9717 20.3139 21.3655 20.7012L30.0576 29.2494C30.4514 29.6367 30.4566 30.2698 30.0694 30.6636L28.8193 31.9348C28.432 32.3285 27.7989 32.3338 27.4051 31.9466L18.713 23.3983Z",
    fill: "#383838",
    stroke: "#525252",
    strokeWidth: 1.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 10.75,
    stroke: "#525252",
    strokeWidth: 3.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.99062c036d7fa5475cd3dc67f1b9b1bb.svg";
export { ForwardRef as ReactComponent };